export default __webpack_public_path__ + "static/media/predefined_dark.0bd61ab5.svg";